import { createContext } from 'react';

const AgentContext = createContext<connect.Agent | null>(null);

export default AgentContext;
